// src/useElementDimensions/index.ts
import {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
import { usePrevious } from "@volvo-cars/react-utils";
import throttle from "lodash/throttle";
var useElementDimensions = ({
  disabled = false,
  throttle: throttleValue = 0
} = {}) => {
  const ref = useRef(null);
  let prevHeight = usePrevious(0);
  let prevWidth = usePrevious(0);
  const [dimensions, setDimensions] = useState({
    height: 0,
    width: 0
  });
  const updateDimensions = useCallback(throttle(() => {
    var _a;
    const newDimensions = (_a = ref == null ? void 0 : ref.current) == null ? void 0 : _a.getBoundingClientRect();
    const newHeight = newDimensions == null ? void 0 : newDimensions.height;
    if (!newHeight) {
      return;
    }
    const newWidth = newDimensions == null ? void 0 : newDimensions.width;
    if (!newWidth) {
      return;
    }
    if (newHeight !== prevHeight || newWidth !== prevWidth) {
      setDimensions({
        height: newHeight,
        width: newWidth
      });
      prevHeight = newHeight;
      prevWidth = newWidth;
    }
  }, throttleValue), []);
  useEffect(() => {
    if (disabled)
      return;
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, [disabled, updateDimensions]);
  return [ref, dimensions];
};

// src/useLayoutEffect/index.ts
import { useEffect as useEffect2, useLayoutEffect } from "react";
var useUniversalLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect2;

// src/useResizeObserver/index.ts
import { default as default2 } from "use-resize-observer";
export {
  useElementDimensions,
  useUniversalLayoutEffect as useLayoutEffect,
  default2 as useResizeObserver
};
